import styled from '@emotion/styled';

export const FormContainer = styled.div`
	.priceContainer {
		border-top: 1px solid var(--border-color);
		border-bottom: 1px solid var(--border-color);
	}
`;

export const PaymentCard = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 1rem;
	width: 100%;
	padding: 1.5rem;
	overflow: hidden;

	:hover {
		cursor: pointer;
	}

	:active {
		cursor: default;
	}

	> * :hover {
		cursor: pointer;
	}

	> * :active {
		cursor: default;
	}
	> .icon.rotate {
		transition: all 0.5s ease;
		transform: rotate(270deg);
	}
	> .icon.rotate0 {
		transition: all 0.5s ease;
		transform: rotate(90deg);
	}
	&.collapse-header {
		border-top: 1px solid var(--border-color);
		margin-top: var(--padding-2);
		padding-top: var(--padding-5);
		justify-content: space-between;
	}
`;

export const BillingInfoContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: 1rem;
	width: 100%;
	padding: 1.5rem;
	overflow: hidden;
	border-top: 1px solid var(--border-color);
	margin-top: var(--padding-2);
	padding-top: var(--padding-5);
`;

export const CompletedContainer = styled.div`
	padding-top: 4rem;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;

	.typography {
		text-align: center;
		line-height: 4rem;
		width: 80%;
	}
`;

export const CreditCardContainer = styled.div`
	overflow: auto;
	display: flex;
	flex-wrap: wrap;
	width: 100%;
	padding-left: var(--padding-4);
	body[dir='rtl'] & {
		padding-left: 0;
		padding-right: var(--padding-4);
	}
`;
